import { apiSlice } from "../../app/api/apiSlice";

import { setCurrentUserName } from "./resetSlice";

export const resetApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    reset: builder.mutation({
      query: (username) => ({
        url: "/auth/reset",
        method: "POST",
        body: { ...username },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const { resetUserName } = data;

          dispatch(setCurrentUserName({ username: resetUserName }));
        } catch (err) {
          console.error(err);
        }
      },
    }),
    update: builder.mutation({
      query: (credentials) => ({
        url: "/auth/new-credentials",
        method: "POST",
        body: { ...credentials },
      }),
    }),
  }),
});

export const { useResetMutation, useUpdateMutation } = resetApiSlice;
